import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Login from "./Pages/Login";
import Home from "./Pages/Home";

import ChartDetailsPage from "./Pages/Reports.js/chartpage";
import ProfilePage from "./Pages/ProfilePage";

import TripDetail from "./Pages/TripDetail";
import RequestTrip from "./Pages/RequestTrip";
import Expense from "./Pages/Expense";
import ViewExpense from "./Pages/ViewExpense";
import ViewTrip from "./Pages/ViewTrip";
import TripUpload from "./Pages/TripUpload";
import TripApproval from "./Pages/TripApproval";
import ViewSalaryUpdationData from "./Pages/ViewSalaryUpdationData";
import Event from "./Pages/Event";
import ViewEvent from "./Pages/ViewEvent";
import EventApproval from "./Pages/EventApproval";
import ExpenseApproval from "./Pages/ExpenseApproval";
import BudgetMaster from "./Pages/BudgetMaster";
import ViewBudgetMaster from "./Pages/ViewBudgetMaster";
import CostCenterMaster from "./Pages/CostCenterMaster";
import ViewCostCenterMaster from "./Pages/ViewCostCenterMaster";
import CompanyLocationMaster from "./Pages/CompanyLocationMaster";
import ViewCompanyLocationMaster from "./Pages/ViewCompanyLocationMaster";
import MerchantMaster from "./Pages/MerchantMaster";
import ViewMerchantMaster from "./Pages/ViewMerchantMaster";
import GradeMaster from "./Pages/GradeMaster";
import ViewGradeMaster from "./Pages/ViewGradeMaster";
import AccountCodeMaster from "./Pages/AccountCodeMaster";
import ViewAccountCodeMaster from "./Pages/ViewAccountCodeMaster";
import ViewPayRoll from "./Pages/ViewPayRoll";
import PaymentFileScreen from "./Pages/PaymentFileScreen";
import AchdDataWithUTR from "./Pages/AchdDataWithUTR";
import ResourceList from "./Pages/ResourceList";
import WorkingDays from "./Pages/WorkingDays";
import UserAttendance from "./Pages/UserAttendance";
import ViewUserAttendance from "./Pages/ViewUserAttendance";
import DeductionMaster from "./Pages/DeductionMaster";
import ViewDeductions from "./Pages/ViewDeductions";
import ViewSalary from "./Pages/ViewSalary";
import OfficeMaster from "./Pages/OfficeMaster";
import CurrencyMaster from "./Pages/CurrencyMaster";
import AdvanceRequest from "./Pages/AdvanceRequest";
import ViewAdvanceCashData from "./Pages/ViewAdvanceCashData";
import AdvanceRequestApproval from "./Pages/AdvanceRequestApproval";
import BalanceAdjustmentAdvanceReq from "./Pages/BalanceAdjustmentAdvanceReq";
import ViewBalanceAdjustmentAdvanceReq from "./Pages/ViewBalanceAdjustmentAdvanceReq";
import AmountDisbursement from "./Pages/AmountDisbursement";
import ViewDisbursement from "./Pages/ViewDisbursement";
import VendorInvoice from "./Pages/VendorInvoice";
import VendorInvoiceApproval from "./Pages/VendorInvoiceApproval";
import IncomingPO from "./Pages/IncomingPO";
import ResourceMaster from "./Pages/ResourceMaster";
import HSNMaster from "./Pages/HSNMaster";
import ViewHSNData from "./Pages/ViewHSNData";
import ReportingWbsReport from "./Pages/ReportingWbsReport";
import ItemMaster from "./Pages/ItemMaster";
import TaxCodeLogistics from "./Pages/TaxCodeLogistics";
import CostCenterOfficeMapping from "./Pages/CostCenterOfficeMapping";
import CustomerMaster from "./Pages/CustomerMaster";
import ViewCustomerDetails from "./Pages/ViewCustomerDetails";
import ViewOfficeMaster from "./Pages/ViewOfficeMaster";
import GLMaster from "./Pages/GLMaster";
import EmployeeTypeMaster from "./Pages/EmployeeTypeMaster";
import ViewItems from "./Pages/ViewItems";
import ViewRegion from "./Pages/ViewRegion";
import ViewReportingWbsReport from "./Pages/ViewReportingWbsReport";
import ViewTaxCodeLogistics from "./Pages/ViewTaxCodeLogistics";
import ViewCurrencyMaster from "./Pages/ViewCurrencyMaster";
import ViewCustomerMaster from "./Pages/ViewCustomerMaster";
import ViewFundsCenter from "./Pages/ViewFundsCenter";
import FundsCenter from "./Pages/FundsCenter";
import ViewCostCenterOfficeMapping from "./Pages/ViewCostCenterOfficeMapping";
import ViewGLMaster from "./Pages/ViewGLMaster";
import ViewCountry from "./Pages/ViewCountry";
import ViewDepartmentMaster from "./Pages/ViewDepartmentMaster";
import CountryMaster from "./Pages/CountryMaster";
import BankMaster from "./Pages/BankMaster";
import ViewBankMaster from "./Pages/ViewBankMaster";

import BankManagement from "./Pages/BankManagement";
import PaymentDateGroupMaster from "./Pages/PaymentDateGroupMaster";
import ViewPaymentDateGroupMaster from "./Pages/ViewPaymentDateGroupMaster";
import ItemTypeMaster from "./Pages/ItemTypeMaster";
import DepartmentMaster from "./Pages/DepartmentMaster";
import RegionMaster from "./Pages/RegionMaster";
import RoleMaster from "./Pages/RoleMaster";
import HouseBank from "./Pages/HouseBank";
import TicketTimeCard from "./Pages/TicketTimeCard";
import ViewHouseBank from "./Pages/ViewHouseBank";
import TaxCategory from "./Pages/TaxCategory";
import ItemGroup from "./Pages/ItemGroup";
import ViewItemGroup1 from "./Pages/ViewItemGroup1";
import ItemGroup2 from "./Pages/ItemGroup2";
import ViewItemGroup2 from "./Pages/ViewItemGroup2";
import ItemGroup3 from "./Pages/ItemGroup3";
import ViewItemGroup3 from "./Pages/ViewItemGroup3";
import ValuationMethod from "./Pages/ValuationMethod";
import CostCenterGroup from "./Pages/CostCenterGroup";
import ViewCostCenterGroup from "./Pages/ViewCostCenterGroup";
import ViewEmployeeType from "./Pages/ViewEmployeeType";
import ViewRoleMaster from "./Pages/ViewRoleMaster";
import AddressDetails from "./Pages/AddressDetails";
import ViewItemTypes from "./Pages/ViewItemTypes";
import ViewItemGroups from "./Pages/ViewItemGroups";
import ViewValuationMethod from "./Pages/ViewValuationMethod";
import ViewTaxCategory from "./Pages/ViewTaxCategory";
import StoreMaster from "./Pages/StoreMaster";
import ViewStoreMaster from "./Pages/ViewStoreMaster";
import ViewProjectResourceMapping from "./Pages/ViewProjectResourceMapping";
import PurchaseRequisition from "./Pages/PurchaseRequisition";
import ViewPurchaseRequisition from "./Pages/ViewPurchaseRequisition";
import SalaryUpdation from "./Pages/SalaryUpdation";
import UploadBankStatements from "./Pages/UploadBankStatements";
import PurchaseOrder from "./Pages/PurchaseOrder";
import ViewPurchaseOrder from "./Pages/ViewPurchaseOrder";
import ProjectMaster from "./Pages/ProjectMaster";
import ViewProjects from "./Pages/ViewProjects";
import ProjectView from "./Pages/ProjectView";
import TaskMaster from "./Pages/TaskMaster";
import MyAssignments from "./Pages/MyAssignments";
// import TaskTemplateModal from "./Pages/TaskTemplateModal";
// import ViewTasks from "./components/ViewTasks"; // You'll need to create this
import ProVenMapping from "./Pages/ProVenMapping";
import CustomerType from "./Pages/CustomerType";
import ViewProVenMapping from "./Pages/ViewProVenMapping";
import UnitMaster from "./Pages/UnitMaster";
import ViewUnitMaster from "./Pages/ViewUnitMaster";
import ItemGroup1 from "./Pages/ItemGroup1";
import ExchangeRate from "./Pages/ExchangeRate";
import ViewExchangeRates from "./Pages/ViewExchangeRates";
import ViewCustomerType from "./Pages/ViewCustomerType";
import ExternalSystem from "./Pages/ExternalSystem";
import ViewExternalSystem from "./Pages/ViewExternalSystem";
import CustomerTabs from "./Pages/CustomerTabs";
import EducationDetails from "./Pages/EducationDetails";
import CustomerExternalIds from "./Pages/CustomerExternalIds";
import ResourceTabs from "./Pages/ResourceTabs";
import DailyTimeCard from "./Pages/DailyTimeCard";
import TimeCardReport from "./Pages/TimeCardReport";
import TicketTimeCardReport from "./Pages/TicketTimeCardReport";
import DistrictMaster from "./Pages/DistrictMaster";
import ViewDistrictMaster from "./Pages/ViewDistrictMaster";
import TehsilMaster from "./Pages/TehsilMaster";
import ViewTehsilMaster from "./Pages/ViewTehsilMaster";
import CityMaster from "./Pages/CityMaster";
import ViewCities from "./Pages/ViewCities";
import BrandGroup from "./Pages/BrandGroup";
import ViewUnPostedInvoice from "./Pages/ViewUnPostedInvoice";
import ViewPostedInvoice from "./Pages/ViewPostedInvoice";
import Token from "./Pages/Token";
import CreateInvoice from "./Pages/CreateInvoice";
import CreateInvoiceItem from "./Pages/CreateInvoiceItem";
import Invoice from "./Pages/Invoice";
import ShippingAddress from "./Pages/ShippingAddress";
import SupplyTypeMaster from "./Pages/SupplyTypeMaster";
import ViewSupplyTypeMaster from "./Pages/ViewSupplyTypeMaster";
import DashboardTicketTimecard from "./Pages/DashboardTicketTimecard";
import { ToastContainer } from "react-toastify";
import ProtectedLayout from "./ProtectedLayout";
import VendorList from "./Pages/vendorList";
import ViewVendorDetails from "./Pages/ViewVendorDetails";
import EditVendor from "./Pages/EditVendor";

import ResourceLedger from "./Pages/Reports.js/resourceLedger";

// import HrDashboardDropdownDynamic from "./Pages/Reports.js/HrDashboard";
import HrDashboard from "./Pages/HrDashboard";
import InventoryDashboard from "./Pages/Reports.js/Inventory";

import CFODashboard from "./Pages/Reports.js/financial";
import Purchase from "./Pages/Reports.js/purchase";
import ProductionDashboard from "./Pages/Reports.js/product";
import AttendanceDetails from "./Pages/Reports.js/AttendanceDetails";
import RequestLeave from "./Api/RequestLeave";
import ViewLeaves from "./Pages/ViewLeaves";

import PayrollDashboard from "./Pages/Reports.js/PayrollDashboard";
import UsageDashboard from "./Pages/Reports.js/UsageDashboard";
import LeaveBalancePage from "./Pages/viewAllLeave";

import Ticket from "./Pages/Ticket";

import TeamMaster from "./Pages/TeamMaster";

import ResourceAllocationReport from "./Pages/ResourceAllocationReport";
import DepartmentList from "./Pages/DepartmentList";
import "./App.css";

import AddAssets from "./Pages/Assets/AddAssets";
import UpdateAsset from "./Pages/Assets/UpdateAsset";
import AssetList from "./Pages/Assets/AssetList";
import AssignAsset from "./Pages/Assets/AssignAsset";
import AssignedAssetList from "./Pages/Assets/AssignedAssetList";
import AddAssetService from "./Pages/Assets/AddAssetService";
import AssetServiceList from "./Pages/Assets/AssetServiceList";
import UpdateAssetStatus from "./Pages/Assets/UpdateAssetStatus";

import RequestService from "./Pages/Services/RequestService";
import RequestList from "./Pages/Services/RequestList";
import RequestData from "./Pages/Services/RequestData";
//import PrDashboard from "./Pages/PrDashboard";
import ViewHrOrgDocuments from "./Pages/ViewHrOrgDocuments";

// import IncomingPo from "./Pages/OrderToCash/IncomingPo";

import AddNodes from "./Pages/Sidebar/AddNodes";

import { AuthProvider } from "./Context/AuthContext";
import CustomerRequestList from "./Pages/Services/CustomerRequestList";
import CustomerServiceList from "./Pages/Services/CustomerServiceList";
import CustomerRequestData from "./Pages/Services/CustomerRequestData";
import ManagerRequestList from "./Pages/Services/ManagerRequestList";
import ManagerRequestData from "./Pages/Services/ManagerRequestData";

import ReconciliationDocument from "./Pages/ReconciliationDocument";
import ReconciliationCockpit from "./Pages/ReconciliationCockpit";
import ManualBankReconciliation from "./Pages/ManualBankReconciliation";
import StplTransferReconciliation from "./Pages/StplTransferReconciliation";
import PaymentReconciliation from "./Pages/PaymentReconciliation";
import PersonalReconciliation from "./Pages/PersonalReconciliation";
import BankRecoDocType from "./Pages/BankRecoDocType";

import AdminDoneService from "./Pages/Services/AdminDoneService";

import RawLeads from "./Pages/CRM/RawLeads";
import CreateRawLead from "./Pages/CRM/CreateRawLead";
import LeadScreen from "./Pages/CRM/LeadScreen";
import UpdateRawLead from "./Pages/CRM/UpdateRawLead";
import LeadsList from "./Pages/CRM/LeadsList";

import NotFound from "./Pages/NotFound";
import Unauthorized from "./Pages/Unauthorized";
import RoleRoute from "./Context/RoleRoute";
import InvoiceDispatchDetails from "./Pages/InvoiceDispatchDetails";
import InvoicePrintTest from "./Pages/invoicePrintTest";

import BatchMaster from "./Pages/BatchMaster";

import Reports from "./Pages/Reports.js/Reports";
import CommitmentMaster from "./Pages/CommitmentMaster";
import ViewCommitmentMaster from "./Pages/ViewCommitmentMater";
import EditCommitment from "./Pages/EditCommitment";

import AdvancePayment from "./Pages/AdvancePaymennt";
import ViewAdvancePayments from "./Pages/ViewAdvancePayment";
import ApproveAdvancePayments from "./Pages/ApproveAdvancePayment";
import CustomerLedger from "./Pages/CustomerLedger";
import VendorMaster from "./Pages/VendorMaster";
import InventoryMaster from "./Pages/InventoryMaster";
import InventoryScreen from "./Pages/viewInventory";
import InventoryDetail from "./Pages/InventoryDetails";
import VendorInvoiceScreen from "./Pages/VendorInvoiceNew";
import VendorInvoicesList from "./Pages/ViewVendorInvoices";
import VendorInvoicePrint from "./Pages/VendorInvoicePrint";
import VendorInvoicePrintTest from "./Pages/VendorInvoicePrint";
import StationMaster from "./Pages/StationMaster";

import ProductionStation from "./Pages/ProductionStation";
import ProductionSubProcesses from "./Pages/ProductionSubProcesses";
import ProductionProcess from "./Pages/ProductionProcess";
import PorductionPlan from "./Pages/ProductionPlan";
import ProductionOrder from "./Pages/ProductionOrder";
import CreateProductionOrder from "./Pages/CreateProductionOrder";
import ExecuteProductionOrder from "./Pages/ExecuteProductionOrder";
import AllProductionOrders from "./Pages/ViewProductionOrder";
import InventoryStatusScreen from "./Pages/InventoryStatusScreen";
import CreditNoteHeader from "./Pages/CreditNoteHeader";
import CreditNoteItems from "./Pages/CreditNoteItems";
import ViewCreditNotes from "./Pages/ViewCreditNotes";
import CreditNotePrint from "./Pages/CreditNotePrint";
import Attendance from "./Pages/Attendance";
import PunchInMaster from "./Pages/PunchInMaster";
import { useAuth } from "./Context/AuthContext";
import AssetMasterForm from "./Pages/AssetMaster";
import AssetDetails from "./Pages/ViewAssets";
import BOMMasterForm from "./Pages/BomMaster";
import ViewBOMs from "./Pages/ViewBOMs";
import PurchaseOrderDetails from "./Pages/PurchaseOrderDetails";
import VendorInvoiceWithoutPO from "./Pages/VendorInvoiceWithoutPO";
import EditCustomer from "./Styling/EditCustomer";
import PoPrint from "./Pages/poPrint";
import UpdateInvoiceItem from "./Pages/UpdateInvoiceItems";
import UpdateShippingAddress from "./Pages/UpdateShipping";
import InventoryStockIn from "./Pages/InventoryStockIn";
import StockOut from "./Pages/InventoryStockOut";
import PayrollScreen from "./Pages/CalculatePayroll";
import ViewPayrollNew from "./Pages/ViewPayrollNew";
import ViewPostedPayrollNew from "./Pages/viewPostedPayroll";
import UpdateResource from "./Pages/UpdateResource";
import EditVendorInvoiceWithoutPO from "./Pages/EditVendorInoivceWithoutPO";
import DebitNoteHeader from "./Pages/DebitNoteHeader";
import ProjectDashboard from "./Pages/Reports.js/ProjectDashboard";
import PersonalDashboard from "./Pages/Reports.js/PersonalDashboard";
import BalanceSheetReport from "./Pages/balancesheet";
import ViewBatches from "./Pages/ViewBatches";
import EditBatches from "./Pages/EditBatches";
import ViewBankStatement from "./Pages/ViewBankStatements";

import ProfitLossReport from "./Pages/profit&losesheet";
import MicrosoftSuccess from "./Pages/MicrosoftSuccess";
import DebitNoteItems from "./Pages/DebitNoteItems";
import DebitNotePrint from "./Pages/DebitNotePrint";
import CEODashboard from "./Api/CEODashboard";

import HedgeRateMaster from "./Pages/HedgeRateMaster";
import ViewHedgeRateMaster from "./Pages/ViewHedgeRate";

import GeneralLedger from "./Pages/Reports.js/GeneralLedger";

import ViewPaidDays from "./Pages/ViewPaidDays";
import VendorLedger from "./Pages/Reports.js/VendorLedger";
import ItemLedger from "./Pages/Reports.js/item_ledger";
import AssetLedger from "./Pages/Reports.js/AssetLedger";

import TrialBalanceReport from "./Pages/TrailBalance";

import JVScreen from "./Pages/JVScreen";
import ViewJVScreen from "./Pages/ViewJV";
import OrgNotifications from "./Pages/OrgNotifications";
import HolidayMasterOrg from "./Pages/HolidayMasterOrg";
import SalarySlipHr from "./Pages/SalarySlipHr";
import DocPoliciesEmp from "./Pages/DocPoliciesEmp";
import PostDocument from "./Pages/PostDocument";
import OpenInvoices from "./Pages/OpenInvoices";
import TicketInfoPage from "./Pages/TicketInfoPage";
import Amazon_ExcelUploadScreen from "./Pages/Amazon_ExcelUploadScreen";
import Amazon_BC_inv_item_errorScreen from "./Pages/Amazon_BC_inv_item_errorScreen";
import Amazon_BC_inv_header_errorScreen from "./Pages/Amazon_BC_inv_header_errorScreen";
import MahOrdersTable from "./Pages/Amazon_OrdersTable";
import AmzOrderItemMapping from "./Pages/Amazon_Order_item_mapping_Screen";
import Navi1EmployeeList from "./Pages/Navi1EmployeeList";
import Navi1Dashboard from "./Pages/Navi1DashBoard";
import Navi1LeadsManagement from "./Pages/Navi1LeadManagement";
import Navi1OnlineTests from "./Pages/Navi1OnlineTest";


import Login2 from "./Pages/Login2";
import NewHire from "./Pages/NewHire";
import SeaFaresEmployeeDetailsNavi1 from "./Pages/SeafaresEmployeeDetailsNavi1";
import NewHireDashboardNavi1 from "./Pages/NewHireDashboardNavi1";
import InterviewSchedulingNavi1 from "./Pages/InterViewSchedulingNavi1";
function App() {
  const storedUser = localStorage.getItem("userDetails");
  const hostname = window.location.hostname;


  const user = {
    userId: 1, // Replace with actual logged-in user ID
  };

  return (
    <Router>
      <AuthProvider>
        <ToastContainer />
        <Routes>
          <Route path="/" element={ <Login />} />
          <Route path="/token/:token" element={<Token />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/microsoft-success" element={<MicrosoftSuccess />} />

          <Route element={<ProtectedLayout />}>
            {/* <Route path="/nodes/add-nodes" element={<AddNodes />} /> */}
            <Route path="org-notification" element={<OrgNotifications />} />
            <Route path="/home" element={<Home />} />
            <Route path="/vendormaster" element={<VendorMaster />} />
            {/* <Route path="/resourceList" element={<RoleRoute roles={["Executive", "Manager"]}><ResourceList /></RoleRoute>} /> */}
            <Route path="/resourceList" element={<ResourceList />} />
            <Route path="/create-invoice" element={<CreateInvoice />} />

            {/* <Route path="/admin" element={<RoleRoute roles={["admin"]}><AdminPage /></RoleRoute>} /> */}

            {/* <Route path="/create-invoice" element={<RoleRoute roles={["Executive", "Manager"]}><CreateInvoice /></RoleRoute>} /> */}
            <Route
              path="/create-invoice/:invoiceId"
              element={<CreateInvoiceItem />}
            />
            <Route
              path="/shippingAddress/:invoiceId"
              element={<ShippingAddress />}
            />

            <Route
              path="/viewUnpostedInvoice"
              element={<ViewUnPostedInvoice />}
            />
            <Route path="/viewpostedInvoice" element={<ViewPostedInvoice />} />
            <Route
              path="/invoice/dispatchdetails/:invoiceId"
              element={<InvoiceDispatchDetails />}
            />
            <Route path="/supplyTypeMaster" element={<SupplyTypeMaster />} />
            <Route
              path="/viewSupplyTypeMaster"
              element={<ViewSupplyTypeMaster />}
            />
            <Route path="/invoice/:id" element={<InvoicePrintTest />} />

            <Route path="/trip-detail" element={<TripDetail />} />
            <Route path="/requestTrip" element={<RequestTrip />} />
            <Route path="/tax-category" element={<TaxCategory />} />
            <Route path="/office-master" element={<OfficeMaster />} />
            <Route path="/itemTypeMaster" element={<ItemTypeMaster />} />
            <Route path="/viewItemTypes" element={<ViewItemTypes />} />
            <Route path="/valuationMethod" element={<ValuationMethod />} />
            <Route path="/viewTaxCategory" element={<ViewTaxCategory />} />
            <Route path="/districtMaster" element={<DistrictMaster />} />
            <Route
              path="/viewDistrictMaster"
              element={<ViewDistrictMaster />}
            />
            <Route
              path="/viewValuationMethod"
              element={<ViewValuationMethod />}
            />
            <Route path="/viewCustomerType" element={<ViewCustomerType />} />
            <Route path="/external-system" element={<ExternalSystem />} />
            <Route
              path="/viewExternalSystem"
              element={<ViewExternalSystem />}
            />
            <Route path="/tehsilMaster" element={<TehsilMaster />} />
            <Route path="/viewTehsilMaster" element={<ViewTehsilMaster />} />
            <Route path="/cityMaster" element={<CityMaster />} />
            <Route path="/viewCities" element={<ViewCities />} />
            {/* <Route path="/customer-external-ids" element={<CustomerTabs />} /> */}
            <Route path="/itemGroup" element={<ItemGroup />} />
            <Route path="/viewItemGroups" element={<ViewItemGroups />} />
            <Route
              path="/viewProjectResourceMapping"
              element={<ViewProjectResourceMapping />}
            />
            <Route path="/unit-master" element={<UnitMaster />} />
            <Route path="/viewUnitMaster" element={<ViewUnitMaster />} />
            <Route path="/viewRegion" element={<ViewRegion />} />
            <Route path="/item-group1" element={<ItemGroup1 />} />
            <Route path="/viewItemGroup1" element={<ViewItemGroup1 />} />
            <Route path="/item-group2" element={<ItemGroup2 />} />
            <Route path="/viewItemGroup2" element={<ViewItemGroup2 />} />
            <Route path="/itemGroup3" element={<ItemGroup3 />} />
            <Route path="/viewItemGroup3" element={<ViewItemGroup3 />} />
            <Route path="/expense" element={<Expense />} />
            <Route path="/country-master" element={<CountryMaster />} />
            <Route path="/viewCountry" element={<ViewCountry />} />
            <Route path="/costCenterGroup" element={<CostCenterGroup />} />
            <Route
              path="/viewCostCenterGroup"
              element={<ViewCostCenterGroup />}
            />
            <Route path="/storeMaster" element={<StoreMaster />} />
            <Route path="/viewStoreMaster" element={<ViewStoreMaster />} />
            <Route path="/departmentMaster" element={<DepartmentMaster />} />
            <Route
              path="/purchase-requisition"
              element={<PurchaseRequisition />}
            />
            <Route
              path="/viewPurchaseRequisition"
              element={<ViewPurchaseRequisition />}
            />
            <Route path="/purchase-order" element={<PurchaseOrder />} />
            <Route path="/viewPurchaseOrder" element={<ViewPurchaseOrder />} />
            <Route path="/projectMaster" element={<ProjectMaster />} />
            <Route path="/viewProjects" element={<ViewProjects />} />
            <Route path="/ticket-view" element={<Ticket />} />
            <Route path="/project/:projectId" element={<ProjectView />} />
            <Route path="/addTask" element={<TaskMaster />} />
            <Route path="/my-task-assignments" element={<MyAssignments />} />

            {/* <Route path="/taskTemplateModal" element={<TaskTemplateModal />} /> */}
            <Route path="/teamMaster" element={<TeamMaster />} />

            <Route
              path="/resource-allocation-report"
              element={<ResourceAllocationReport />}
            />
            <Route path="/Asset-Ledger" element={<AssetLedger />} />
            <Route path="/Trail-Balance" element={<TrialBalanceReport />} />

            <Route path="/roleMaster" element={<RoleMaster />} />
            <Route path="/viewRoleMaster" element={<ViewRoleMaster />} />
            <Route
              path="/ticket-timecard-report"
              element={<TicketTimeCardReport />}
            />
            <Route path="/exchange-rate" element={<ExchangeRate />} />
            <Route path="/viewExchangeRates" element={<ViewExchangeRates />} />
            <Route path="/tax-code-logistics" element={<TaxCodeLogistics />} />
            <Route
              path="/viewDepartmentMaster"
              element={<ViewDepartmentMaster />}
            />
            <Route path="/ticket-time-card" element={<TicketTimeCard />} />
            <Route path="/bankMaster" element={<BankMaster />} />
            <Route path="/bankManagement" element={<BankManagement />} />

            <Route path="/viewBankMaster" element={<ViewBankMaster />} />
            <Route path="/house-bank" element={<HouseBank />} />
            <Route path="/viewHouseBank" element={<ViewHouseBank />} />
            <Route
              path="/upload-bank-statements"
              element={<UploadBankStatements />}
            />
            <Route path="/currency-master" element={<CurrencyMaster />} />
            <Route
              path="/reconciliation-document"
              element={<ReconciliationDocument />}
            />
            <Route
              path="/reconciliation-cockpit"
              element={<ReconciliationCockpit />}
            />
            {/* <Route
              path="/manual-Bank-reconciliation"
              element={<ManualBankReconciliation />}
            />
            <Route
              path="/StplTransferReconciliation"
              element={<StplTransferReconciliation />}
            /> */}
            <Route
              path="/manual-Bank-reconciliation/:monthId?/:houseBankId?"
              element={<ManualBankReconciliation />}
            />
            <Route
              path="/StplTransferReconciliation/:monthId/:houseBankId"
              element={<StplTransferReconciliation />}
            />
            {/* <Route
              path="/PaymentReconciliation"
              element={<PaymentReconciliation />}
            /> */}
            <Route
              path="/PaymentReconciliation/:monthId?/:houseBankId?"
              element={<PaymentReconciliation />}
            />
            {/* <Route
              path="/PersonalReconciliation"
              element={<PersonalReconciliation />}
            /> */}
            <Route
              path="/PersonalReconciliation/:monthId/:houseBankId"
              element={<PersonalReconciliation />}
            />
            <Route path="/BankRecDocType" element={<BankRecoDocType />} />
            <Route
              path="/paymentDateGroupMaster"
              element={<PaymentDateGroupMaster />}
            />
            <Route
              path="/viewPaymentDateGroupMaster"
              element={<ViewPaymentDateGroupMaster />}
            />
            <Route
              path="/cost-center-office-mapping"
              element={<CostCenterOfficeMapping />}
            />
            <Route path="/funds-center" element={<FundsCenter />} />
            <Route path="/reporting-wbs" element={<ReportingWbsReport />} />
            <Route
              path="/view-reporting-wbs"
              element={<ViewReportingWbsReport />}
            />
            <Route
              path="/viewleaveBalanceMonthly"
              element={<LeaveBalancePage />}
            />

            <Route path="/view-funds-center" element={<ViewFundsCenter />} />
            <Route path="/viewExpense" element={<ViewExpense />} />
            <Route path="/viewTrip" element={<ViewTrip />} />
            <Route path="/resource-master" element={<ResourceMaster />} />
            <Route path="/region-master" element={<RegionMaster />} />
            <Route
              path="/employeeTypeMaster"
              element={<EmployeeTypeMaster />}
            />
            <Route path="/viewEmployeeType" element={<ViewEmployeeType />} />
            <Route path="/incoming-po" element={<IncomingPO />} />
            <Route path="/tripUpload" element={<TripUpload />} />
            <Route path="/tripApproval" element={<TripApproval />} />
            <Route path="/pro-ven-mapping" element={<ProVenMapping />} />
            <Route path="/viewProVenMapping" element={<ViewProVenMapping />} />
            <Route path="/event" element={<Event />} />
            <Route
              path="/view-tax-code-logistics"
              element={<ViewTaxCodeLogistics />}
            />
            <Route
              path="/view-customer-master"
              element={<ViewCustomerMaster />}
            />
            <Route
              path="/view-currency-master"
              element={<ViewCurrencyMaster />}
            />
            <Route path="/customer-type" element={<CustomerType />} />
            <Route path="/batchmaster" element={<BatchMaster />} />
            <Route path="/gl-master" element={<GLMaster />} />
            <Route path="/viewEvent" element={<ViewEvent />} />
            <Route path="/eventApproval" element={<EventApproval />} />
            <Route
              path="/view-cost-center-office-mapping"
              element={<ViewCostCenterOfficeMapping />}
            />
            <Route path="/view-gl-master" element={<ViewGLMaster />} />
            <Route path="/view-office-master" element={<ViewOfficeMaster />} />
            <Route
              path="/reporting-wbs-report"
              element={<ReportingWbsReport />}
            />
            <Route path="/expenseApproval" element={<ExpenseApproval />} />
            <Route path="/budgetMaster" element={<BudgetMaster />} />
            <Route path="/viewBudgetMaster" element={<ViewBudgetMaster />} />
            <Route path="/costCenterMaster" element={<CostCenterMaster />} />
            <Route path="/customer-master" element={<CustomerTabs />} />
            <Route
              path="/viewCostCenterMaster"
              element={<ViewCostCenterMaster />}
            />
            <Route
              path="/companyLocationMaster"
              element={<CompanyLocationMaster />}
            />
            <Route
              path="/viewCompanyLocationMaster"
              element={<ViewCompanyLocationMaster />}
            />
            <Route path="/merchantMaster" element={<MerchantMaster />} />
            <Route
              path="/viewMerchantMaster"
              element={<ViewMerchantMaster />}
            />
            <Route path="/gradeMaster" element={<GradeMaster />} />
            <Route path="/viewGradeMaster" element={<ViewGradeMaster />} />
            <Route path="/accountCodeMaster" element={<AccountCodeMaster />} />
            <Route
              path="/viewAccountCodeMaster"
              element={<ViewAccountCodeMaster />}
            />
            <Route path="/viewPayRoll" element={<ViewPayRoll />} />
            <Route path="/paymentFileScreen" element={<PaymentFileScreen />} />
            <Route path="/achdDataWithUTR" element={<AchdDataWithUTR />} />
            <Route path="/workingDays" element={<WorkingDays />} />
            <Route path="/userAttendance" element={<UserAttendance />} />
            <Route
              path="/viewUserAttendance"
              element={<ViewUserAttendance />}
            />
            <Route path="/resource-ledger" element={<ResourceLedger />} />
            <Route path="/General-Ledger" element={<GeneralLedger />} />
            <Route path="/deductionMaster" element={<DeductionMaster />} />

            <Route path="/viewDeductions" element={<ViewDeductions />} />
            <Route path="/viewSalary" element={<ViewSalary />} />
            <Route path="/advanceRequest" element={<AdvanceRequest />} />
            <Route
              path="/viewAdvanceCashData"
              element={<ViewAdvanceCashData />}
            />
            <Route
              path="editVendorInvoice/:id"
              element={<EditVendorInvoiceWithoutPO />}
            />
            <Route
              path="/advanceRequestApproval"
              element={<AdvanceRequestApproval />}
            />
            <Route
              path="/balanceAdjustment"
              element={<BalanceAdjustmentAdvanceReq />}
            />
            <Route
              path="/viewBalanceAdjustment"
              element={<ViewBalanceAdjustmentAdvanceReq />}
            />
            <Route
              path="/amountDisbursement"
              element={<AmountDisbursement />}
            />
            <Route path="/viewDisbursement" element={<ViewDisbursement />} />
            <Route path="/vendorInvoice" element={<VendorInvoice />} />
            <Route
              path="/vendorInvoiceApproval"
              element={<VendorInvoiceApproval />}
            />
            <Route path="/hsnMaster" element={<HSNMaster />} />
            <Route path="/viewHSNData" element={<ViewHSNData />} />
            <Route path="/itemMaster" element={<ItemMaster />} />
            <Route path="/view-items" element={<ViewItems />} />
            <Route path="/daily-time-card" element={<DailyTimeCard />} />
            <Route path="/time-card-report" element={<TimeCardReport />} />
            <Route path="/assets/add-assets" element={<AddAssets />} />
            <Route path="/assets/update-asset/:id" element={<UpdateAsset />} />
            <Route path="/assets/view-assets" element={<AssetList />} />
            <Route path="/assets/assign-assets" element={<AssignAsset />} />

            <Route
              path="/assets/assigned-asset-list"
              element={<AssignedAssetList />}
            />
            <Route
              path="/assets/add-asset-service"
              element={<AddAssetService />}
            />
            <Route
              path="/assets/asset-service-list"
              element={<AssetServiceList />}
            />
            <Route
              path="/assets/update-asset-status"
              element={<UpdateAssetStatus />}
            />
            <Route path="/personal-dashboard" element={<PersonalDashboard />} />

            <Route path="/roleMaster" element={<RoleMaster />} />
            <Route path="/commitmentMaster" element={<CommitmentMaster />} />
            <Route path="/viewcommitment" element={<ViewCommitmentMaster />} />
            <Route path="/commitment/:id/edit" element={<EditCommitment />} />
            <Route path="/viewRoleMaster" element={<ViewRoleMaster />} />
            <Route
              path="/ticket-timecard-report"
              element={<TicketTimeCardReport />}
            />
            <Route path="/exchange-rate" element={<ExchangeRate />} />
            <Route path="/viewExchangeRates" element={<ViewExchangeRates />} />
            <Route path="/tax-code-logistics" element={<TaxCodeLogistics />} />
            <Route
              path="/viewDepartmentMaster"
              element={<ViewDepartmentMaster />}
            />
            <Route path="/ticket-time-card" element={<TicketTimeCard />} />
            <Route path="/bankMaster" element={<BankMaster />} />
            <Route path="/bankManagement" element={<BankManagement />} />

            <Route path="/viewBankMaster" element={<ViewBankMaster />} />
            <Route path="/house-bank" element={<HouseBank />} />
            <Route path="/viewHouseBank" element={<ViewHouseBank />} />
            <Route
              path="/upload-bank-statements"
              element={<UploadBankStatements />}
            />
            <Route path="/currency-master" element={<CurrencyMaster />} />
            <Route
              path="/paymentDateGroupMaster"
              element={<PaymentDateGroupMaster />}
            />
            <Route
              path="/viewPaymentDateGroupMaster"
              element={<ViewPaymentDateGroupMaster />}
            />
            <Route
              path="/cost-center-office-mapping"
              element={<CostCenterOfficeMapping />}
            />
            <Route path="/funds-center" element={<FundsCenter />} />
            <Route path="/reporting-wbs" element={<ReportingWbsReport />} />
            <Route
              path="/view-reporting-wbs"
              element={<ViewReportingWbsReport />}
            />
            <Route path="/view-funds-center" element={<ViewFundsCenter />} />
            <Route path="/viewExpense" element={<ViewExpense />} />
            <Route path="/viewTrip" element={<ViewTrip />} />
            <Route path="/resource-master" element={<ResourceTabs />} />
            <Route path="/education-details" element={<ResourceTabs />} />
            <Route path="/address-details" element={<ResourceTabs />} />
            <Route path="/region-master" element={<RegionMaster />} />

            <Route path="/inventory" element={<InventoryMaster />} />

            <Route path="/viewInventory" element={<InventoryScreen />} />
            <Route
              path="/inventoryStatus"
              element={<InventoryStatusScreen />}
            />
            <Route path="/inventory/:receiptId" element={<InventoryDetail />} />
            <Route
              path="/employeeTypeMaster"
              element={<EmployeeTypeMaster />}
            />
            <Route path="/CEO-Dashboard" element={<CEODashboard />} />

            <Route path="/viewEmployeeType" element={<ViewEmployeeType />} />
            <Route path="/incoming-po" element={<IncomingPO />} />
            <Route path="/tripUpload" element={<TripUpload />} />
            <Route path="/tripApproval" element={<TripApproval />} />
            <Route path="/pro-ven-mapping" element={<ProVenMapping />} />
            <Route path="/viewProVenMapping" element={<ViewProVenMapping />} />
            <Route path="/event" element={<Event />} />
            <Route
              path="/view-tax-code-logistics"
              element={<ViewTaxCodeLogistics />}
            />
            <Route
              path="/view-customer-master"
              element={<ViewCustomerMaster />}
            />
            <Route
              path="/view-currency-master"
              element={<ViewCurrencyMaster />}
            />
            <Route path="/customer-type" element={<CustomerType />} />
            <Route path="/gl-master" element={<GLMaster />} />
            <Route path="/viewEvent" element={<ViewEvent />} />
            <Route path="/eventApproval" element={<EventApproval />} />
            <Route
              path="/view-cost-center-office-mapping"
              element={<ViewCostCenterOfficeMapping />}
            />
            <Route path="/view-gl-master" element={<ViewGLMaster />} />
            <Route path="/view-office-master" element={<ViewOfficeMaster />} />
            <Route
              path="/reporting-wbs-report"
              element={<ReportingWbsReport />}
            />
            <Route path="/expenseApproval" element={<ExpenseApproval />} />
            <Route path="/budgetMaster" element={<BudgetMaster />} />
            <Route path="/viewBudgetMaster" element={<ViewBudgetMaster />} />
            <Route path="/costCenterMaster" element={<CostCenterMaster />} />
            <Route path="/customer-master" element={<CustomerTabs />} />
            <Route
              path="/viewCustomer/:customerCode"
              element={<ViewCustomerDetails />}
            />
            <Route
              path="/viewCostCenterMaster"
              element={<ViewCostCenterMaster />}
            />
            <Route
              path="/companyLocationMaster"
              element={<CompanyLocationMaster />}
            />
            <Route
              path="/viewCompanyLocationMaster"
              element={<ViewCompanyLocationMaster />}
            />
            <Route path="/merchantMaster" element={<MerchantMaster />} />
            <Route
              path="/viewMerchantMaster"
              element={<ViewMerchantMaster />}
            />
            <Route path="/gradeMaster" element={<GradeMaster />} />
            <Route path="/viewGradeMaster" element={<ViewGradeMaster />} />
            <Route path="/accountCodeMaster" element={<AccountCodeMaster />} />
            <Route
              path="/viewAccountCodeMaster"
              element={<ViewAccountCodeMaster />}
            />
            <Route path="/viewPayRoll" element={<ViewPayRoll />} />
            <Route path="/paymentFileScreen" element={<PaymentFileScreen />} />
            <Route path="/achdDataWithUTR" element={<AchdDataWithUTR />} />
            <Route path="/resourceList" element={<ResourceList />} />
            <Route path="/workingDays" element={<WorkingDays />} />
            <Route path="/userAttendance" element={<UserAttendance />} />
            <Route
              path="/viewUserAttendance"
              element={<ViewUserAttendance />}
            />
            <Route path="/deductionMaster" element={<DeductionMaster />} />
            <Route path="/viewDeductions" element={<ViewDeductions />} />
            <Route path="/viewSalary" element={<ViewSalary />} />
            <Route path="/advanceRequest" element={<AdvanceRequest />} />
            <Route
              path="/viewAdvanceCashData"
              element={<ViewAdvanceCashData />}
            />
            <Route
              path="/advanceRequestApproval"
              element={<AdvanceRequestApproval />}
            />
            <Route
              path="/balanceAdjustment"
              element={<BalanceAdjustmentAdvanceReq />}
            />
            <Route
              path="/viewBalanceAdjustment"
              element={<ViewBalanceAdjustmentAdvanceReq />}
            />
            <Route
              path="/amountDisbursement"
              element={<AmountDisbursement />}
            />
            <Route path="/viewDisbursement" element={<ViewDisbursement />} />
            <Route path="/vendorInvoice" element={<VendorInvoice />} />

            <Route
              path="/vendorInvoiceApproval"
              element={<VendorInvoiceApproval />}
            />
            <Route path="/vendorInvoices" element={<VendorInvoiceScreen />} />
            <Route
              path="/viewVendorInvoices"
              element={<VendorInvoicesList />}
            />
            <Route
              path="/VendorInvoicePrint/:InvoiceId"
              element={<VendorInvoicePrintTest />}
            />

            <Route path="/hsnMaster" element={<HSNMaster />} />
            <Route path="/viewHSNData" element={<ViewHSNData />} />
            <Route path="/itemMaster" element={<ItemMaster />} />
            <Route path="/view-items" element={<ViewItems />} />
            <Route path="/daily-time-card" element={<DailyTimeCard />} />
            <Route path="/time-card-report" element={<TimeCardReport />} />
            <Route path="/assets/add-assets" element={<AddAssets />} />
            <Route path="/assets/update-asset/:id" element={<UpdateAsset />} />
            <Route path="/assets/view-assets" element={<AssetList />} />
            <Route path="/assets/assign-assets" element={<AssignAsset />} />
            <Route
              path="/assets/assigned-asset-list"
              element={<AssignedAssetList />}
            />
            <Route
              path="/assets/add-asset-service"
              element={<AddAssetService />}
            />
            <Route
              path="/assets/asset-service-list"
              element={<AssetServiceList />}
            />
            <Route
              path="/assets/update-asset-status"
              element={<UpdateAssetStatus />}
            />
            <Route path="/ProjectDashboard" element={<ProjectDashboard />} />

            <Route
              path="/services/request-service"
              element={<RequestService />}
            />
            <Route
              path="/services/request-list/customer/:id"
              element={<CustomerRequestData />}
            />

            <Route path="/StationMaster" element={<StationMaster />} />

            <Route path="/ProductionStation" element={<ProductionStation />} />
            <Route
              path="/ProductionSubProcesses"
              element={<ProductionSubProcesses />}
            />
            <Route path="/ProductionProcess" element={<ProductionProcess />} />
            <Route path="/ProductionPlan" element={<PorductionPlan />} />

            <Route
              path="/services/admin-request-list"
              element={<RequestList />}
            />
            <Route
              path="/services/request-list/:id"
              element={<RequestData />}
            />
            <Route
              path="/services/admin-done-service"
              element={<AdminDoneService />}
            />

            <Route
              path="/services/customer-request-list"
              element={<CustomerRequestList />}
            />
            <Route
              path="/services/customer-service-list"
              element={<CustomerServiceList />}
            />

            <Route
              path="/services/manager-request-list"
              element={<ManagerRequestList />}
            />
            <Route
              path="/services/request-list/manager/:id"
              element={<ManagerRequestData />}
            />

            <Route path="/crm/raw-leads" element={<RawLeads />} />
            <Route path="/crm/create-raw-lead" element={<CreateRawLead />} />
            <Route path="/crm/lead-screen/:id" element={<LeadScreen />} />
            <Route path="/crm/update-rawlead/:id" element={<UpdateRawLead />} />
            <Route path="/crm/leads-list" element={<LeadsList />} />

            <Route
              path="/assets/assigned-asset-list"
              element={<AssignedAssetList />}
            />
            <Route
              path="/assets/add-asset-service"
              element={<AddAssetService />}
            />
            <Route
              path="/assets/asset-service-list"
              element={<AssetServiceList />}
            />
            <Route
              path="/assets/update-asset-status"
              element={<UpdateAssetStatus />}
            />

            <Route
              path="/services/request-service"
              element={<RequestService />}
            />
            <Route
              path="/services/admin-request-list"
              element={<RequestList />}
            />
            <Route
              path="/services/customer-request-list"
              element={<CustomerRequestList />}
            />
            <Route
              path="/services/customer-request-list"
              element={<CustomerRequestList />}
            />
            <Route
              path="/services/manager-request-list"
              element={<ManagerRequestList />}
            />
            <Route path="/Vendor-Ledger" element={<VendorLedger />} />
            <Route
              path="/services/request-list/:id"
              element={<RequestData />}
            />
            <Route
              path="/services/request-list/customer/:id"
              element={<CustomerRequestData />}
            />
            <Route
              path="/services/request-list/manager/:id"
              element={<ManagerRequestData />}
            />
            {/* <Route
              path="/dashboard-form"
              elemment={<PrDashboard />}
            /> */}
            {/* <Route
              path="/hr-dashboard"
              element={<HrDashboardDropdownDynamic user={user} />}
            /> */}
            <Route path="/hr-dashboard" element={<HrDashboard user={user} />} />
            <Route path="/usage-dashboard" element={<UsageDashboard />} />

            <Route path="/attendance-details" element={<AttendanceDetails />} />
            <Route path="/viewBatches" element={<ViewBatches />} />
            <Route path="/editBatch/:batchId" element={<EditBatches />} />

            <Route path="/request-leave" element={<RequestLeave />} />

            <Route
              path="/Inventory-dashboard"
              element={<InventoryDashboard />}
            />

            <Route path="/vendors/list" element={<VendorList />} />
            <Route
              path="/viewVendor/:vendorCode"
              element={<ViewVendorDetails />}
            />
            <Route path="/vendors/edit/:vendorCode" element={<EditVendor />} />
            <Route path="/Item-ledger" element={<ItemLedger />} />

            <Route path="/financial-dashboard" element={<CFODashboard />} />
            <Route path="/purchase-dashboard" element={<Purchase />} />

            <Route
              path="/product-dashboard"
              element={<ProductionDashboard />}
            />
            <Route path="/balance-Sheet" element={<BalanceSheetReport />} />
            <Route path="/profit-loss-Sheet" element={<ProfitLossReport />} />

            <Route path="/payroll-dashboard" element={<PayrollDashboard />} />
            <Route path="/view-leaves" element={<ViewLeaves />} />

            <Route path="/dashboard-reports" element={<Reports />} />

            <Route path="/chart-details" element={<ChartDetailsPage />} />
            <Route path="/production-order" element={<ProductionOrder />} />
            <Route
              path="/createProduction-order/:planId"
              element={<CreateProductionOrder />}
            />
            <Route
              path="/executeProduction-order/:productionOrderId"
              element={<ExecuteProductionOrder />}
            />
            <Route
              path="/viewProductionOrder"
              element={<AllProductionOrders />}
            />
            <Route path="/creditNoteHeader" element={<CreditNoteHeader />} />
            <Route
              path="/creditNote/:creditNoteId"
              element={<CreditNoteItems />}
            />
            <Route
              path="/debitNote/:creditNoteId"
              element={<DebitNoteItems />}
            />
            <Route path="/viewcreditNote" element={<ViewCreditNotes />} />
            <Route
              path="/creditNotePrint/:creditNoteId"
              element={<CreditNotePrint />}
            />
            <Route
              path="/debitNotePrint/:creditNoteId"
              element={<DebitNotePrint />}
            />
            <Route path="/debitNoteHeader" element={<DebitNoteHeader />} />
            <Route path="/attendance" element={<Attendance />} />
            <Route path="/punchInMaster" element={<PunchInMaster />} />

            <Route
              path="/viewadvancePayment"
              element={<ViewAdvancePayments />}
            />
            <Route
              path="/approveadvancepayment"
              element={<ApproveAdvancePayments />}
            />
            <Route path="/advancepayment" element={<AdvancePayment />} />

            <Route path="/assetMaster" element={<AssetMasterForm />} />
            <Route path="/viewAsset" element={<AssetDetails />} />
            <Route path="/bomMaster" element={<BOMMasterForm />} />
            <Route path="/viewBom" element={<ViewBOMs />} />

            <Route path="/purchase-orders/:id" element={<PoPrint />} />
            <Route
              path="/vendorInvoiceWithoutPO"
              element={<VendorInvoiceWithoutPO />}
            />
            <Route
              path="/editCustomer/:customerCode"
              element={<EditCustomer />}
            />
            <Route path="/profile-page" element={<ProfilePage />} />
            <Route
              path="updateInvoice/:invoiceId"
              element={<UpdateInvoiceItem />}
            />
            <Route
              path="updateShipping/:invoiceId"
              element={<UpdateShippingAddress />}
            />
            <Route path="/inventoryStockIn" element={<InventoryStockIn />} />
            <Route path="/inventoryStockOut" element={<StockOut />} />
            <Route path="/calculatePayroll" element={<PayrollScreen />} />
            <Route path="/viewPayroll/:id" element={<ViewPayrollNew />} />
            <Route
              path="/viewPostedPayroll/:id"
              element={<ViewPostedPayrollNew />}
            />
            <Route path="/updateResource/:id" element={<UpdateResource />} />
            <Route
              path="/viewadvancePayment"
              element={<ViewAdvancePayments />}
            />
            <Route
              path="/approveadvancepayment"
              element={<ApproveAdvancePayments />}
            />

            <Route path="/advancepayment" element={<AdvancePayment />} />
            <Route path="/purchase-orders/:id" element={<PoPrint />} />
            <Route
              path="/vendorInvoiceWithoutPO"
              element={<VendorInvoiceWithoutPO />}
            />
            <Route
              path="/editCustomer/:customerCode"
              element={<EditCustomer />}
            />

            <Route path="/profile-page" element={<ProfilePage />} />

            <Route path="/hr-org-documents" element={<ViewHrOrgDocuments />} />

            <Route
              path="updateInvoice/:invoiceId"
              element={<UpdateInvoiceItem />}
            />
            <Route
              path="/post-document/:monthId/:houseBankId"
              element={<PostDocument />}
            />
            <Route
              path="/open-invoices/:customerCode"
              element={<OpenInvoices />}
            />

            <Route path="/customerledger" element={<CustomerLedger />} />
            <Route path="/viewBankStatements" element={<ViewBankStatement />} />
            <Route path="/hedgeRateMaster" element={<HedgeRateMaster />} />
            <Route path="/JVScreen" element={<JVScreen />} />
            <Route path="/viewJv" element={<ViewJVScreen />} />
            <Route
              path="/viewHedgeRateMaster"
              element={<ViewHedgeRateMaster />}
            />
            <Route path="/holiday-master" element={<HolidayMasterOrg />} />

            <Route path="/department-list" element={<DepartmentList />} />
            <Route path="/viewPaidDays" element={<ViewPaidDays />} />
            <Route path="/salary-slip-hr" element={<SalarySlipHr />} />
            <Route path="/policies-emp" element={<DocPoliciesEmp />} />
            <Route path="/ticketinfo/:ticketId" element={<TicketInfoPage />} />
            <Route
              path="/Amazon-ExcelUploadScreen"
              element={<Amazon_ExcelUploadScreen />}
            />
            <Route
              path="/Amazon-InvItem-error"
              element={<Amazon_BC_inv_item_errorScreen />}
            />
            <Route
              path="/Amazon-InvHeader-error"
              element={<Amazon_BC_inv_header_errorScreen />}
            />
            <Route path="/amazon-mtr-screen" element={<MahOrdersTable />} />
            <Route
              path="/amazon-order-item-mapping-screen"
              element={<AmzOrderItemMapping />}
            />



              {/* Navi1  Project */}
              

             {/* <Route path="/EmployeeList" element={<EmployeeList />} /> */}





            <Route path="/EmployeeList" element={<Navi1EmployeeList />} />
            <Route path="/Navi1Dashboard" element={<Navi1Dashboard />} />
            <Route path="/Navi1LeadsManagement" element={<Navi1LeadsManagement />} />
            <Route path="/Navi1OnlineTests" element={<Navi1OnlineTests />} />

            <Route path="/new-hire" element={<NewHire />} />
            <Route path="/newHireDashboard" element={<NewHireDashboardNavi1 />} />
            <Route path="/seaFaresEmployeeDetails" element={<SeaFaresEmployeeDetailsNavi1 />} />
            <Route path="/interviewScheduling" element={<InterviewSchedulingNavi1 />} />
            <Route path="/navi1LeadManagement" element={<Navi1LeadsManagement />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
